import api from './api';

export const ALLOWED = ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf'];
export const MAX_BYTES = 10 * 1024 * 1024;

// Presigns + uploads a single File directly to S3, returns attachment metadata.
export async function uploadSupportFile(file, ticketId = 'new') {
  if (!ALLOWED.includes(file.type)) throw new Error('Only PNG, JPG or PDF files are allowed');
  if (file.size > MAX_BYTES) throw new Error('File exceeds the 10 MB limit');
  const { data } = await api.post('/support/attachments/presign', {
    filename: file.name, content_type: file.type, size: file.size, ticket_id: ticketId,
  });
  const put = await fetch(data.upload_url, {
    method: 'PUT', headers: { 'Content-Type': file.type }, body: file,
  });
  if (!put.ok) throw new Error('Upload failed');
  return { key: data.key, filename: data.filename, content_type: data.content_type, size: data.size };
}

export async function downloadSupportFile(att) {
  const { data } = await api.get('/support/attachments/download', {
    params: { key: att.key, filename: att.filename },
  });
  window.open(data.url, '_blank', 'noopener');
}

export function fmtSize(bytes) {
  if (!bytes) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}
